export const INCIDENT_TYPE = "incidentType";
export const DESCRIPTION = "description";
